<!-- 券仓plus-支付兑换码-兑换记录 -->
<template>
  <div class="my-order-page-content">
    <van-list
      v-model:loading="loading"
      :finished="finished"
      :finished-text="orderList.length > 0 ? '没有更多了' : ''"
      @load="() => getOrderList()"
    >
      <div class="content-box">
        <div
          v-for="order in orderList"
          :key="order.combinationOrderNo"
          class="order-card"
        >
          <div class="order-card-top">
            <span v-if="order.orderVoStatus === 1 && order.durationTimeObj">
              <van-count-down
                class="text1"
                :time="order.durationTimeObj"
                format="HH:mm:ss"
                @finish="onTimeUp"
              />
              <span>后订单将取消</span>
            </span>
            <span v-else>{{ order.placeorderTime }}</span>
            <span :class="`status${order.orderVoStatus}`">{{
              orderStatus[order.orderVoStatus]
            }}</span>
          </div>
          <!-- 图文详情 -->
          <div class="order-card-info">
            <div
              v-for="item in order.clientSubOrderVoList"
              :key="item.id"
              class="order-detail"
            >
              <ul>
                <li>
                  <span class="label">订单号：</span>
                  <span class="name">{{ item.combinationOrderNo }}</span>
                </li>
                <li>
                  <span class="label">订单金额：</span>
                  <span class="name">{{
                    order.combinationPayAmount / 100
                  }}</span>
                </li>
                <li v-if="order.placeorderEndTime">
                  <span class="label">支付时间：</span>
                  <span class="name">{{ order.placeorderEndTime }}</span>
                </li>
                <li>
                  <span class="label">商品名称：</span>
                  <span class="name">{{ item.hjSiteProductName }}</span>
                </li>
                <li v-if="order.decryptSelfCouponId">
                  <span class="label">兑换码：</span>
                  <span class="name">{{ order.decryptSelfCouponId }}</span>
                </li>
                <li v-if="item.clientAccount">
                  <span class="label">充值账户：</span>
                  <span class="name">{{ item.clientAccount }}</span>
                </li>
                <li v-if="order.receiverName">
                  <span class="label">收货人姓名：</span>
                  <span class="name">{{ order.receiverName }}</span>
                </li>
                <li v-if="order.receiverPhone">
                  <span class="label">收货人手机号：</span>
                  <span class="name">{{ order.receiverPhone }}</span>
                </li>
                <li v-if="order.receiverAddress">
                  <span class="label">收货人地址：</span>
                  <span class="name">{{ order.receiverAddress }}</span>
                </li>
              </ul>
              <div class="right">
                <!-- <img
                  class="seal"
                  :src="require(`@/assets/imgs/scenario/payExchange/seal1.png`)"
                />
                <div class="err-tip">
                  异常提示: 商品限定银行卡-退款成功/退款失败,出现异常提示
                </div> -->

                <img
                  v-if="[2, 3].includes(order.orderVoStatus)"
                  class="seal"
                  :src="
                    require(`@/assets/imgs/scenario/payExchange/seal${item.subOrderVoStatus}.png`)
                  "
                />
                <!-- 商品限定银行卡-退款成功/退款失败,出现异常提示 -->
                <div
                  v-if="
                    [5, 6].includes(order.orderVoStatus) && order.coRefundReason
                  "
                  class="err-tip"
                >
                  异常提示: {{ order.coRefundReason }}
                </div>
              </div>
            </div>
            <div v-if="order.orderVoStatus === 1" class="order-card-bottom">
              <van-button
                type="primary"
                color="#000"
                block
                round
                class="btn"
                @click="toPay(order)"
                >去支付</van-button
              >
            </div>
          </div>
        </div>
      </div>
    </van-list>
    <div v-if="orderList.length === 0 && !loading" className="empty-box">
      <img
        :src="require('@/assets/imgs/scenario/payExchange/cart1.png')"
        alt=""
      />
      <div>暂无内容</div>
    </div>
  </div>
</template>

<script>
import {
  reactive,
  toRefs,
  onMounted,
  computed,
  onActivated,
  watchEffect,
} from "vue";
import { useRoute, useRouter, } from "vue-router";
import { useStore } from "vuex";
import { wxApiEmpower } from '@/utils/common'
import { NumbertoMultiply } from "@/utils/accuracyCalculation";
import moment from "moment";
import { getClientOrderListApi, ordertoPayApi } from "@/api/huijuinterface";
import dic from './dictionaryData'
import { Toast } from 'vant'

let init = true;
export default {
  name: "MyOrdef",
  components: {},
  beforeRouteEnter(to, from, next) {
    init = from.name !== "orderDetail";
    next();
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const store = useStore();
    const state = reactive({
      title: "兑换记录",
      orderStatus: {},
      currentStatus: "",
      orderList: [],
      tabList: [
        {
          id: "",
          name: "全部",
        },
        {
          id: 1,
          name: "待付款",
        },
        {
          id: 2,
          name: "待发货",
        },
        {
          id: 3,
          name: "已完成",
        },
      ],
      loading: false,
      finished: false,
      total: 0,
      size: 10,
      currentPage: 1,
    });
    const styleMap = computed(() => store.state.styleMap);
    const appletInfo = computed(() => store.state.appletInfo);

    onMounted(() => {
      // 登录失效返回首页
      if (!sessionStorage.getItem('huijuToken')) {
        let query = sessionStorage.getItem('scenPayExchangeQuery')
        if (query) query = JSON.parse(query)
        router.replace({ path: '/scenPayExchange', query })
      }

      wxApiEmpower()
      // setTimeout(() => {
      //   console.log('定时器执行');
      //   getOrderList({})
      // }, 5000);
      let _orderStatus = {};
      dic.orderStatus.map((i) => {
        _orderStatus[i.dictionaryValue] = i.dictionaryName;
      });
      state.orderStatus = _orderStatus;
    });
    onActivated(() => {
      document.title = state.title;
      getOrderList({ current: 1 });
    });

    // 下单接口
    const toPay = async (order) => {
      // 如果没有手机号,先手机号登录
      if (order.orderVoStatus !== 1) return
      try {
        let parames = {
          combinationOrderNo: order.combinationOrderNo,
        };
        ordertoPayApi(parames)
          .then((res) => {
            // this.handleLoading(false)
            let data = res.data;
            if (!data) return Toast("支付异常！");
            let payResult = {
              timestamp: data.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
              nonceStr: data.nonceStr, // 支付签名随机串，不长于 32 位
              package: data.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
              signType: data.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
              paySign: data.paySign, // 支付签名
            };
            /* eslint-disable-next-line no-undef */
            wx.chooseWXPay({
              ...payResult,
              success() {
                getOrderList({ current: 1 });
              },
              complete(res) {
                console.log(res, 'complete');

              },
            });
          })

      } catch (res) {
        // this.handleLoading(false)
      }
    }

    const getOrderList = async (obj = {}) => {
      const _current = obj.current || state.currentPage;
      const _currentStatus = obj.currentStatus || state.currentStatus;
      const params = {
        pageNum: _current,
        pageSize: state.size,
        param: {
          orderStatus: _currentStatus || "",
        },
      };
      await getClientOrderListApi(params).then((res) => {
        // let res = resData //
        let _orderList = formatOrderList(res.data.records);
        _orderList = formatOrderMergeList(_orderList);
        _orderList.map(i => {
          i.clientSubOrderVoList.map(i => {
            // 非直充类型商品，不展示充值账户
            if (i.hjSiteProductShowType !== 2) {
              i.clientAccount = undefined
            }
          })
        })


        if (_current === 1) {
          state.orderList = _orderList;
        } else {
          const newCouponList = [...state.orderList, ..._orderList];
          state.orderList = newCouponList;
        }

        // console.log(state.orderList);

        state.total = res.data.total;
        state.loading = false;
        if (state.total < state.currentPage * state.size) state.finished = true;
        state.currentPage++;
      });
    };

    // 倒计时结束
    const onTimeUp = () => {
      getOrderList({ current: 1 });
    };


    // 订单格式化
    const formatOrderList = (data) => {
      let currentTime = moment() // 当前时间
      if (Array.isArray(data)) {
        data.map(o => {
          o.allCount = 0
          if (o.couponAmount > 0) {
            let _redBankName = o.redBankName && o.redBankName.replace(/（|）/g, '')
            o.infoStr = `${_redBankName || ''}支付立减 `
          }
          if (o.couponType) {
            //折扣金额
            const discount = (100 - o.discount) / 100
            o.deduction = Number((o.combinationAmount * discount).toFixed(0))
          }
          if (o.combinationAmount) o.combinationAmount = o.combinationAmount - o.deduction //支付总金额-自建券金额
          o.totalOffer = Number(o.deduction) + Number(o.couponAmount)
          let orderVoStatusOne = dic.orderStatus.find(j => j.dictionaryValue === o.orderVoStatus)
          o.orderVoStatusName = orderVoStatusOne && orderVoStatusOne.dictionaryName // 订单状态对应名称
          // 订单-商品数据
          o.clientSubOrderVoList.map(g => {
            g.pointRate = o.pointRate // 订单积分比例
            g.count = 1 // 数量默认为1
            o.allCount++
            g.showPlace = g.hjSiteProductShowPlace
            g.showClassification = g.hjSiteProductShowClassification
            g.showType = g.hjSiteProductShowType
            // 是否显示修改账号按钮，直充，支付券除了微信都可以编辑账号
            if (g.hjSiteProductShowType === 0 && g.hjSiteProductShowClassification !== 0) {
              g.isModifyAccount = true
            }
            if (g.hjSiteProductShowType === 2) {
              g.isModifyAccount = true
            }
            // 商品优惠金额,若该商品是秒杀商品，则商品优惠=商品原价-销售价；若该商品不是秒杀商品则不展示
            if (g.showPlace) {
              g.showPlace = g.showPlace.toString().split(',').map(i => Number(i))
              g.secondKill = g.showPlace.includes(1) // 秒杀
            }
            g.preferential = '无'
            if (g.secondKill && g.originalPrice) {
              g.preferential = g.originalPrice - g.subSaleAmount
            }
          })
          // 待发货
          if (o.orderVoStatus === 1) {
            const _placeorderTime = moment(o.placeorderTime).add(10, 'minutes') // 下单时间的未来10分钟
            let diffTime = _placeorderTime.diff(currentTime)
            if (diffTime > 0) {
              o.durationTimeObj = diffTime   // 距订单结束的时间
            }
            // console.log(o.durationTimeObj, 'o.durationTimeObj=');
          }
          if (o.payPoint && typeof o.payPoint === 'string') {
            o.payPoint = parseFloat(o.payPoint)
          }
        })
        // console.log(data);
        return data
      } else {
        return []
      }
    }

    // 订单列表相同商品合并成一条
    const formatOrderMergeList = (data) => {
      if (Array.isArray(data)) {
        data.map(o => {
          // 订单-商品数据
          let _clientSubOrderVoList = []
          o.clientSubOrderVoList.map(g => {
            let one = _clientSubOrderVoList.find(i => i.hjSiteProductId === g.hjSiteProductId)
            if (one) {
              one.count++ // 已存在商品，数量累加
            } else {
              _clientSubOrderVoList.push(g)
            }
          })
          _clientSubOrderVoList.map(g => {
            g.subDiscountAmount = NumbertoMultiply(Number(g.subDiscountAmount), g.count)
            if (g.secondKill && g.originalPrice) {
              g.preferential = NumbertoMultiply(g.preferential, g.count)
            }
          })
          o.clientSubOrderVoList = _clientSubOrderVoList
        })
        return data
      } else {
        return []
      }
    }
    const handleClick = (value) => {
      state.currentPage = 1;
      state.finished = false;
      state.currentStatus = value;
      window, scrollTo(0, 0);
      getOrderList({ currentStatus: value, current: 1 });
    };

    return {
      ...toRefs(state),
      handleClick,
      route,
      router,
      styleMap,
      onTimeUp,
      getOrderList,
      toPay,
      appletInfo,
    };
  },
};
</script>

<style lang="less" scoped>
.my-order-page-content {
  background: #f5f5f7;
  min-height: 100vh;
  padding: 10px 0;
  box-sizing: border-box;

  .content-box {
    margin: 0px 15px 15px 15px;
    .order-card {
      background: #fff;
      border-radius: 10px;
      padding: 0px 15px;
      margin-bottom: 10px;
      .order-card-top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 50px;
        color: #999;
        font-size: 12px;
        border-bottom: 1px solid #f0f0f0;
        .text1 {
          display: inline-block;
          padding-right: 5px;
          color: #1a1a1a;
          font-size: 12px;
        }
        .status1 {
          color: red;
        }
        .status2 {
          color: #1a1a1a;
        }
      }
      .order-card-info {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        position: relative;
        .order-detail {
          // border-bottom: 1px solid #f0f0f0;
        }
        ul {
          padding: 10px 0 15px 0;
          font-size: 14px;
          line-height: 2;
          color: #1a1a1a;
        }

        .right {
          position: absolute;
          right: 0px;
          top: 20px;
          width: 120px;
          text-align: right;
          .seal {
            width: 60px;
            height: 60px;
            margin-bottom: 20px;
          }
          .err-tip {
            font-size: 10px;
            color: #fa0000;
            line-height: 1.5;
            text-align: left;
          }
        }
      }
      .order-card-bottom {
        padding: 10px 0 20px 0;
        border-top: 1px solid #f0f0f0;
        text-align: right;
        .btn {
          margin-left: auto;
          width: 80px;
          height: 30px;
        }
      }
      .tip {
        font-size: 12px;
        color: #dd2026;
        .at-countdown__time-box {
          font-size: 12px !important;
          color: #dd2026 !important;
          min-width: auto !important;
          font-family: none !important;
        }
        .at-countdown__separator {
          padding: 0 4px !important;
        }
      }
    }
  }
  .empty-box {
    width: 100%;
    padding-top: 90px;
    text-align: center;
    font-size: 16px;
    color: #aaaaaa;
    line-height: 2;
    img {
      width: 100px;
      height: 110px;
    }
  }
}
</style>
